import React, { useEffect, useState } from 'react';
import {
    GridView,
    SimpleView,
    Widget,
    Table,
    ColumnProps,
    Button
} from '@digital/ui';
import { Tooltip, Tag } from 'antd';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { SolicitacaoNaoEnviada, getSolicitacoesNaoEnviadas, enviarSolicitacaoAprovador } from '@app/api/naoPrevistos/solicitacao';
import { hasPermission } from '@app/helpers/permissions';

const SolicitacoesNaoEnviadas = () => {
    const [solicitacoes, setSolicitacoes] = useState<SolicitacaoNaoEnviada[]>([]);
    const [loading, setLoading] = useState(false);
    const [enviandoId, setEnviandoId] = useState<string | undefined>(undefined);

    const carregar = () => {
        setLoading(true);
        getSolicitacoesNaoEnviadas()
            .then((result) => {
                setSolicitacoes(Array.isArray(result) ? result : []);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        carregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEnviar = (aprovacaoId: string) => {
        setEnviandoId(aprovacaoId);
        enviarSolicitacaoAprovador(aprovacaoId)
            .then(() => carregar())
            .finally(() => setEnviandoId(undefined));
    };

    const podeEnviar = hasPermission(['NAO_PREVISTO_ADMINISTRADOR']);

    const columns: ColumnProps<SolicitacaoNaoEnviada>[] = [
        {
            title: 'Cod. Solicitação',
            dataIndex: 'codigoSolicitacaoTexto',
            ...mountFormFilterDropDown('codigoSolicitacaoTexto', 'Pesquisar')
        },
        {
            title: 'Nome do Projeto',
            dataIndex: 'nomeProjeto',
            ...mountFormFilterDropDown('nomeProjeto', 'Pesquisar')
        },
        {
            title: 'Solicitante',
            dataIndex: 'solicitante',
            ...mountFormFilterDropDown('solicitante', 'Pesquisar')
        },
        {
            title: 'Aguardando (etapa)',
            dataIndex: 'tipoAprovacaoNome',
            ...mountFormFilterDropDown('tipoAprovacaoNome', 'Pesquisar')
        },
        {
            title: 'Aprovador',
            dataIndex: 'aprovadorNome',
            ...mountFormFilterDropDown('aprovadorNome', 'Pesquisar')
        },
        {
            title: 'Situação',
            dataIndex: '',
            render: (text: any, row: SolicitacaoNaoEnviada) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Tag color="red" style={{ marginRight: 0, width: 'fit-content' }}>Não enviado ao aprovador</Tag>
                    {row.mensagemErroIntegracao &&
                        <Tooltip title={row.mensagemErroIntegracao}>
                            <span style={{ fontSize: 11, color: '#cf1322', maxWidth: 260, display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                Erro: {row.mensagemErroIntegracao}
                            </span>
                        </Tooltip>
                    }
                </div>
            )
        },
        {
            title: 'Data do Último Status',
            dataIndex: 'dataUltimoStatusFormatada',
            ...mountFormFilterDropDown('dataUltimoStatusFormatada', 'Pesquisar')
        },
        {
            title: 'Ações',
            dataIndex: '',
            render: (text: any, row: SolicitacaoNaoEnviada) => (
                <>
                    {podeEnviar &&
                        <Tooltip title="Enviar ao aprovador">
                            <Button
                                type="link"
                                icon="messaging-send"
                                loading={enviandoId === row.aprovacaoId}
                                disabled={enviandoId === row.aprovacaoId}
                                confirm="Deseja enviar esta solicitação ao aprovador?"
                                okText="Sim"
                                cancelText="Não"
                                onClick={() => handleEnviar(row.aprovacaoId)}
                            />
                        </Tooltip>
                    }
                    <Tooltip title="Abrir solicitação">
                        <Button
                            type="link"
                            icon="arrows-circled_up_right_2"
                            onClick={() => window.open(`/naoPrevisto/solicitacao/${row.solicitacaoId}`)}
                        />
                    </Tooltip>
                </>
            )
        }
    ];

    return (
        <SimpleView>
            <GridView>
                <Widget
                    title="Não Previstos - Não Enviados ao Aprovador"
                    extra={
                        <Tooltip title="Atualizar">
                            <Button
                                type="link"
                                icon="arrows-circled_right_2"
                                size="small"
                                loading={loading}
                                onClick={carregar}
                            />
                        </Tooltip>
                    }
                >
                    <Table
                        rowKey="aprovacaoId"
                        columns={columns}
                        dataSource={solicitacoes}
                        loading={loading}
                    />
                </Widget>
            </GridView>
        </SimpleView>
    );
};

export default SolicitacoesNaoEnviadas;
